import { DataFilter } from '@siclop/kstone-vue'
import type { ComponentCategory } from '../enums'

export class WireframeComponentFilter extends DataFilter {
  designSystemId?: number
  code?: string
  category?: ComponentCategory
  isActive?: boolean
  isSystem?: boolean

  constructor(data?: Partial<WireframeComponentFilter>) {
    super(data)
    if (data) {
      this.designSystemId = data.designSystemId
      this.code = data.code
      this.category = data.category
      this.isActive = data.isActive
      this.isSystem = data.isSystem
    }
  }
}
